import React from 'react';

const USPItem = ({ number, title, description }) => {
  return (
    <div className="d-flex align-items-start mb-4 fade-in" style={{ animationDelay: `${number * 0.1}s` }}>
      <div style={{
        minWidth: '60px',
        height: '60px',
        backgroundColor: 'var(--muted-gold)',
        color: 'white',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        marginRight: '1.5rem'
      }}>
        {number}
      </div>
      <div>
        <h3 className="h4 mb-2">{title}</h3>
        <p style={{ color: '#666' }}>{description}</p>
      </div>
    </div>
  );
};

export default USPItem;